import React, { useState, Children, useEffect } from 'react';
import PropTypes from 'prop-types';
import './action.scss';
import AdvancePopover from '../advance-popover/advance-popover';
import { MoreHorNewIcon, SearchIcon } from '../icons/icons';

export default function Action({
  children,
  spacing,
  width,
  disabled,
  hidden,
  label,
  className,
  moreIcon,
  closeOnclick,
  zIndex,
  containerClass,
  onClose,
  icon,
  leftIcon,
  placement,
  enableSearch,
  liStyle,
}) {
  const [eventValue, setEventValue] = useState(null);
  const [search, setSearch] = useState('');

  const getTextFromNode = (node) => {
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return node.toString();
    if (!node) return '';

    if (Array.isArray(node)) {
      return node.map(getTextFromNode).join('');
    }

    if (node?.props?.label) {
      return node.props.label;
    }

    if (node?.props?.children) {
      return getTextFromNode(node.props.children);
    }

    return '';
  };
  const togglePopover = (e) => {
    setEventValue(e.target);
  };

  useEffect(() => {
    setEventValue(null);
  }, [onClose]);

  const handleClose = () => {
    setEventValue(null);
    setSearch('');
  };

  const childrenArray = Children.toArray(children);

  const filteredChildren = childrenArray.filter((child) => {
    if (!search) return true;

    const text = getTextFromNode(child);

    return text.toLowerCase().includes(search.toLowerCase());
  });

  const mappedChildren = filteredChildren.map((child) =>
    child ? <li style={liStyle}>{child}</li> : null
  );

  return !hidden ? (
    <>
      <button
        type="button"
        onClick={togglePopover}
        id="actionPopover"
        className={`more-button d-flex justify-end align-items-center ${className} ${
          eventValue ? 'active' : ''
        }`}
        disabled={disabled || mappedChildren?.length === 0}
      >
        {leftIcon}
        {label !== '' ? label : moreIcon}
        {icon}
      </button>

      <AdvancePopover
        reference="actionPopover"
        getEvent={eventValue}
        closePopover={handleClose}
        placement={placement}
        closeOnclick={closeOnclick}
        zIndex={zIndex}
      >
        <div className="action-list">
          {enableSearch && (
            <div className="action-search">
              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="action-search-icon">
                <SearchIcon />
              </span>
            </div>
          )}

          <ul
            className={`action-list-item ${containerClass}`}
            style={{ padding: spacing, width }}
          >
            {/* {mappedChildren} */}
            {mappedChildren.length ? mappedChildren : <li>No results found</li>}
          </ul>
        </div>
      </AdvancePopover>
    </>
  ) : null;
}
Action.propTypes = {
  children: PropTypes.node.isRequired,
  spacing: PropTypes.string,
  label: PropTypes.string,
  width: PropTypes.string,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  className: PropTypes.string,
  moreIcon: PropTypes.element,
  closeOnclick: PropTypes.bool,
  zIndex: PropTypes.number,
  containerClass: PropTypes.string,
  onClose: PropTypes.bool,
  icon: PropTypes.element.isRequired,
  leftIcon: PropTypes.element.isRequired,
  placement: PropTypes.string,
  enableSearch: PropTypes.bool,
  liStyle: PropTypes.objectOf(Array),
};
Action.defaultProps = {
  spacing: '',
  label: '',
  width: '',
  disabled: false,
  hidden: false,
  className: '',
  moreIcon: <MoreHorNewIcon color="#828282" />,
  closeOnclick: false,
  zIndex: '999999',
  containerClass: '',
  onClose: false,
  placement: 'left',
  enableSearch: false,
  liStyle: {},
};
